import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { HardphoneDetailView } from '../models/hardphone-detail-view.model';
import * as AddHardphoneActions from './add-hardphone.actions';

export const addHardphoneFeatureKey = 'addPhone';

export interface AddHardphoneState {
   callState: CallState;
   phone: HardphoneDetailView | null;
}

export const initialState: AddHardphoneState = {
   callState: LoadingState.Init,
   phone: null,
};

const addHardphoneReducer = createReducer(
   initialState,
   on(AddHardphoneActions.addPhone, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddHardphoneActions.addHardphoneSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddHardphoneActions.addHardphoneFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddHardphoneState | undefined, action: Action) {
   return addHardphoneReducer(state, action);
}
